// extracted by mini-css-extract-plugin
export default {"containerCol":"ContainerCol_containerCol__Lt80k"};